import moment from 'moment';
import React from 'react';
import { EverestAdminRepository } from '../../repository';
import { NavigationBar } from './NavigationBar';

class EverestHome extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      latitude: 0,
      longitude: 0,
      message: null
    };

    this.everestRepository = new EverestAdminRepository();
  }

  componentDidMount() {
    if ('geolocation' in navigator) {
      this.setMessage("geolocation 가능~");
    } else {
      this.setMessage("geolocation 불가능!");
    }
  }

  onClickLocation(e) {
    e.preventDefault();
    this.setMessage("click!");

    navigator.geolocation.getCurrentPosition((position) => {
      // callback(position.coords.latitude, position.coords.longitude);
      this.setMessage("success!");
      this.setState({
        latitude: position.coords.latitude,
        longitude: position.coords.longitude
      });
    }, (err) => {
      var text = JSON.stringify(err);
      this.setMessage(text);
    });
  }

  onClickStamp(e) {
    e.preventDefault();
    this.everestRepository.stamp({
      latitude: this.state.latitude,
      longitude: this.state.longitude
    }, (e) => window.Toast.info("saved position!"));
  }

  setMessage(text) {
    var mmt = moment();
    var message = "[" + mmt.format("yyyy-MM-DD HH:mm:ss") + "] " + text;
    this.setState({ message });
  }

  render() {
    return (
      <React.Fragment>
        <NavigationBar />

        <br />
        <div className={"container"}>
          Welcome to 정상인.
        </div>

        <br />
        <p>
          현재 위치는 <br />
          <input value={this.state.latitude} onChange={(e) => this.setState({ latitude: e.target.value })} />
          <input value={this.state.longitude} onChange={(e) => this.setState({ longitude: e.target.value })} />
        </p>

        <div className={"container"}>
          <div className={"form-group"}>
            <button className={"btn btn-primary"} onClick={this.onClickLocation.bind(this)}>위치</button>
          </div>
          <div className={"form-group"}>
            <button className={"btn btn-primary"} onClick={this.onClickStamp.bind(this)}>도장</button>
          </div>
        </div>

        <br />
        <p>
          {this.state.message || ""}
        </p>
      </React.Fragment>
    );
  }
}

export { EverestHome };
